// extracted by mini-css-extract-plugin
export const footerNav = "FooterNav-module--footer-nav--2dHft";
export const dropdownButton = "FooterNav-module--dropdown-button--3ae6G";
export const dropdownContent = "FooterNav-module--dropdown-content--15oAx";
export const dropdownIcon = "FooterNav-module--dropdown-icon--12zDK";